/**
 * DeleteIcon component - renders a trash/delete icon as SVG
 * @returns React component that renders the delete icon
 */
const DeleteIcon = () => {
  return (
    <svg
      width="12"
      height="15"
      viewBox="0 0 12 15.309"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4751 2.08544C11.4751 2.08544 11.5641 2.14823 10.1793 1.72766C8.93782 1.35079 7.76349 1.26992 7.76349 1.26992L7.6821 0.692934C7.62616 0.294725 7.30016 0 6.91618 0H5.99972H5.08325C4.69978 0 4.37375 0.294725 4.31733 0.692934L4.23594 1.26992C4.23594 1.26992 3.06212 1.35079 1.82067 1.72766C0.435315 2.14826 0.524327 2.08544 0.524327 2.08544C0.215639 2.17062 0 2.46382 0 2.79897V3.29816H5.99975H12V2.79897C12 2.46382 11.7843 2.17062 11.4751 2.08544Z"
        fill="#616161"
      />
      <path
        d="M0.766668 9.7836C0.837351 10.5836 1.50741 11.1969 2.31074 11.1969H9.23332C10.0363 11.1969 10.7067 10.5836 10.7774 9.7836L11.5441 0H0L0.766668 9.7836ZM8.34403 2.16426C8.35928 1.91304 8.57519 1.72153 8.82644 1.7368C9.07766 1.75205 9.2689 1.96796 9.25389 2.21921L8.82058 9.38007C8.80533 9.63129 8.58942 9.82253 8.3382 9.80728C8.08695 9.79203 7.8955 9.57639 7.91075 9.32514L8.34403 2.16426ZM5.3162 2.19173C5.3162 1.93998 5.52015 1.73603 5.77188 1.73603C6.02364 1.73603 6.22755 1.93998 6.22755 2.19173V9.35256C6.22755 9.60432 6.02361 9.80824 5.77188 9.80824C5.52012 9.80824 5.3162 9.60429 5.3162 9.35256V2.19173ZM2.71735 1.7368C2.9686 1.72156 3.18451 1.91304 3.19976 2.16426L3.63358 9.32508C3.64882 9.57633 3.45734 9.79197 3.20612 9.80722C2.95487 9.82247 2.73897 9.63123 2.72372 9.38001L2.2899 2.21915C2.27462 1.96796 2.4661 1.75205 2.71735 1.7368Z"
        transform="translate(0.228, 4.112)"
        fill="#616161"
      />
    </svg>
  );
};

export default DeleteIcon;
